import colors from "./colors";
import bgIcon from "../resources/images/awards_background.png";
export default {
  common: {
    page: {
      display: "flex",
      flexFlow: "column",
      justifyContent: "center",
      padding: 10,
    },
    mainContainer: {
      marginLeft: "5%",
      marginRight: "5%",
    },
    filterRow: {
      display: "flex",
      flexDirection: "row",
      flex: 1,
      justifyContent: "space-evenly",
      alignItems: "center",
    },
    searchWithDropDown: {
      width: "30%",
      display: "flex",
      flexDirection: "row",
    },
    searchField: {
      width: "80%",
      display: "flex",
      flexDirection: "row",
    },
    searchFieldCancel: {
      position: "relative",
      left: -60,
      zIndex: 10,
    },
    row: {
      display: "flex",
      flexDirection: "row",
      flex: 1,
      padding: 10,
      justifyContent: "space-evenly",
      alignItems: "center",
      fontSize: 20,
    },
    cell: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "purple",
      alignItems: "center",
      justifyContent: "center",
    },
    detailsContainer: {
      marginLeft: "5%",
      marginRight: "5%",
    },
    buttonsContainer: {
      display: "flex",
      flexFlow: "row",
      justifyContent: "center",
      alignItems: "center",
      marginTop: 30,
    },
    buttonAlign: {
      marginLeft: -16,
    },
    paperContainer: {
      padding: 20,
      justifyContent: "center",
      marginTop: 20,
      marginBottom: 20,
      borderStyle: "solid",
      borderRadius: 4,
      borderWidth: 0.5,
      borderColor: colors.lightGrey,
    },
    subHeading: {
      marginTop: 10,
      marginBottom: 10,
      color: colors.orange,
      fontWeight: 900,
      fontSize: 20,
    },
    label: {
      color: colors.curiousBlue,
      fontWeight: 700,
      fontSize: 16,
      marginTop: 10,
      marginBottom: 10,
    },
  },
};



// WEBPACK FOOTER //
// ./src/styles/layout.js